<template>
    <div>
        <div class="content">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-sm-12">
                        <div style="width: 100%; margin-top: 50px;">
                            <br>
                            <br>
                            <h1 style="text-align: center;"><translate>Reset your banking connection</translate></h1>
                            <p style="text-align: center;"><translate>This function will reset your banking connection. When you activate the reset with the button below, it will delete any connection to your bank and will allow you to reactivate the connection afterwards. Please note that this will not clear information from your banking page, only delete your connection to your bank.</translate></p>
                            <br>
                            <h4 style="text-align: center; margin-bottom: 20px;"><translate>DO NOT CLOSE TAB WHILE RESETTING.</translate></h4>
                            <form @submit.prevent="onSubmit">
                                <div style="text-align: center;">
                                    <input type="submit" value="Reset bank" class="btn btn-primary" />
                                </div>
                            </form>
                            <br>
                            <p style="text-align: center;"><translate>After the reset, you will be automatically redirected to you banking page in Gekko. There you can easily reconnect your bank account(s).</translate></p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
import BankService from "@/store/services/bank.service.js";
import TitleBar from "@/components/TitleBar";

export default {
    name: 'BankReset',
    components: {TitleBar},
    methods: {
        onSubmit() {
            BankService.bankResetFix().then((response) => {
                if (response.status === 200) {
                    if (response.data.error_code == 'tink_connection_not_found'){
                        this.$store.commit('setAlert', {
                            title: this.$gettext("Success"),
                            text: this.$gettext("Bank connection reset successfully!"),
                            variant: "success",
                            duration: 4
                        });
                    }else {
                        this.$router.push({ name: 'Bank' }); 
                        this.$store.commit('setAlert', {
                            title: this.$gettext("Warning"),
                            text: this.$gettext(response.data.message),
                            variant: "danger",
                            duration: 4
                        });
                     } 
                } 
            }).catch((error) => {
                console.error('Error resetting bank connection:', error); 
            });
        }
    }
}
</script>

<style lang="scss" scoped>
.report-link:hover {
    text-decoration: none;
}

.report-title {
    color: $colorTextBase;
}

.icon-container {
    padding-right: 12px;
    padding-left: 12px;
    align-self: center;
    color: $colorBrand;
    font-size: 30px;
    min-width: 62px;
    text-align: center;
}

.description-container {
    color: $colorTextSemi;
    font-size: 12px;
}

.report-list-element {
    padding-top: 10px;
    padding-bottom: 10px;
    display: flex;
    flex-direction: row;
}

.report-list-element:hover {
    background-color: #eeeeee;

    .report-title {
        color: $colorBrand !important;
    }
}
</style>
